// extracted by mini-css-extract-plugin
export var boxItems = "_bb-1";
export var boxItemsLg = "_bb-2";
export var button = "_bb-7";
export var buttonLg = "_bb-8";
export var filterGroupBox = "_bb-0";
export var icon = "_bb-3";
export var iconSecondary = "_bb-6";
export var iconWrapper = "_bb-4";
export var iconWrapperLg = "_bb-5";